import { render, staticRenderFns } from "./WxDateSelect.vue?vue&type=template&id=281df2a1&scoped=true&"
import script from "./WxDateSelect.vue?vue&type=script&lang=js&"
export * from "./WxDateSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281df2a1",
  null
  
)

export default component.exports